
/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'
/* global getCredentials */

var expocadfx = expocadfx || {};

expocadfx.Sales = function() {
    var config = expocadfx.config;
    var data = expocadfx.fxData;
    var FxEvent = expocadfx.fxevent;
    var util = expocadfx.util;
    var localStorage = expocadfx.localStorage;
    var load = expocadfx.loadScript
    var arBoothGraphics = data.boothGraphics;
    
        // Sales Commands from menu
    var CMD_RENT        = 0;
    var CMD_UNRENT      = 1;
    var CMD_HOLD        = 2;
    var CMD_UNHOLD      = 3;
    var CMD_COMBINE     = 4;
    var CMD_UNCOMBINE   = 5;
    var CMD_DELETE      = 6;
    var CMD_UNDELETE    = 7;
    var CMD_NEW_EXHIBITOR = 8;
    var CMD_DIVIDE      = 9;
	var CMD_EVENT_STATISTICS = 10;
    var CMD_CHANGE_NUMBER = 11;
    var CMD_HATCH_BOOTHS = 12;
    
    var CMD_OPEN_EVENT = 51;
    var CMD_EXHIBITOR_LOGIN = 52;
    
        // EXPOCAD EDGE API command definitions  //
    var CMDACTION_RENTBOOTH = 200;
    var CMDACTION_UNRENTBOOTH = 201;
    var CMDACTION_HOLDBOOTH = 202;
    var CMDACTION_UNHOLDBOOTH = 203;
    var CMDACTION_MOVEEXHIBITOR = 204;
    var CMDACTION_BOOTHNAMEOVERRIDE = 205;
    var CMDACTION_ADDCHILDEXHIBITOR = 206;
    var CMDACTION_REMOVECHILDEXHIBITOR = 207;
    var CMDACTION_DELETEBOOTH = 400;
    var CMDACTION_UNDELETEBOOTH = 401;
    var CMDACTION_CHANGEBOOTHNUMBER = 402;
    var CMDACTION_CREATEBOOTH = 403;
    var CMDACTION_MOVEBOOTH = 404;
    var CMDACTION_COMBINEBOOTH = 500;
    var CMDACTION_UNCOMBINEBOOTH = 501;
    var CMDACTION_RESIZE = 1000;
//    var CMDACTION_SETSHOWINSHOW = 1100;
//    var CMDACTION_CLEARSHOWINSHOW = 1101;
//    var CMDACTION_CREATEPAVILION = 1200;
//    var CMDACTION_DELETEPAVILION = 1201;
//    var CMDACTION_ADDBOOTHTOPAVILION = 1202;
//    var CMDACTION_REMOVEBOOTHFROMPAV = 1203;
    
    var LOST_CONNECTION = "lost_connection";
    
    var commandLabels = [];
    
    var token = "";
    var bSyncInProgress = false;
    var bSyncFromLogin = false;
    var bRequestPending = false;
    var arPendingBooths = [];
    var arPendingRequests = [];
    var fp = null;
    var mgr = null;
    var syncTimer = null;
    
    var lastMsgNumber = data.lastMessageNumber;//-1;
    var totalMessages = 0;      // for progress bar
    var messagesProcessed = 0;     // for progress bar
    var totalBooths = 0;
    var boothsDone = 0;
    
    var pollInterval = 10;      // in seconds
    
    var readyForUpdates = false;
    var loggedIn = false;
    var externalLogout = false;
    var loggedInFromCredentials = false;

    
    
    
    function init( dataManager) {
        mgr = dataManager;
    }
    
    function setConnectionParams( t) {
        token = t;
    }
    
    function addToPending( bth) {
        var index = findInArray( bth);
        if( index === -1) {
            arPendingBooths.push( bth);
        }
    }
    
    function removeFromPending( bth) {
        var index = findInArray( bth);
        if( index !== -1) {
            arPendingBooths.splice( index, 1);
        }
    }
    
    function findInArray( bth) {
        var i = 0;
        var len = arPendingBooths.length;
        for( i = 0; i < len; i++) {
            if( arPendingBooths[i].number === bth.number) {
                return i;
            }
        }
        return -1;
    }
    
    function sendPendingRequest() {
        var obj = arPendingRequests.shift();
        bRequestPending = true;
        sendRequest( obj.type, obj.url, obj.cb, obj.params, obj.token);
    }
    
    function addRequest( type, url, callback, params) {
        if( bRequestPending) {
            arPendingRequests.push( { type: type, url: url, cb: callback, params: params, token: token} );
        }
        else {
            bRequestPending = true;
            sendRequest( type, url, callback, params, token);
        } 
    }
    
    function checkForMore() {
        if( bSyncInProgress) {
            requestLogMessages();
        }
        else if( arPendingBooths.length > 0) {
            requestBoothInfo( arPendingBooths);
        }
        //   else if( pendingExhibitors) ....
        else {
            if( bSyncFromLogin) {
                bSyncFromLogin = false;
                readyForUpdates = true;
                document.dispatchEvent( new FxEvent( "Sync_Progress", {"prog": 1}));
            }
            
            if( arPendingRequests.length > 0) {
                sendPendingRequest();
            }
            else {
                bRequestPending = false;
                if( syncTimer) {
                    clearTimeout( syncTimer);
                }
                if( loggedIn) {
                    syncTimer = setTimeout( syncWithEdge, pollInterval * 1000);
                }
            }
        }
    }
    
    function syncWithEdge() {
        if( readyForUpdates) {
            bSyncInProgress = true;
            if( !bRequestPending) {
                requestLogMessages();
            }
        }
    }
    
    function syncNow( loginFlag) {          // called from 'salesWindow' to force update
        bSyncInProgress = true;
        if( loginFlag) {
            bSyncFromLogin = true;
            boothsDone = 0;
        }
        if( syncTimer) {
            clearTimeout( syncTimer);   //   if timer stopped, what restarts it
        }
        requestLogMessages();
    }
    
    function getBoothObject( bthNum) {
        var bthObj = util.findBoothObject( bthNum, data.booths);
        
        if( bthObj === null) {			// new booth, uncombine, divide
            bthObj = fp.newBooth( bthNum);
            bthObj.exhibitorIndex = String( mgr.newExhibitor( bthNum, bthObj.boothIndex));
        }
        return bthObj;
    }
    
    function cbBoothInfo( msg) {    //  now returns an array of booths
        var boothObj = null;
        var bthNum;
        var font;
        var i = 0;
        var txt;
		var numBooths = 0;
		var boothIndex = 0;
        var graphic = null;
        var currentMsg = null;
        var progress =  0;
        
        if( msg) {
            if( msg.hasOwnProperty( "Code")) {
                console.log( "ERROR: " + msg.Code + "  Msg: " + msg.Message);
                if( msg.Code !== 404) {
                //    alert( "Unknown Error Code  " + msg.Code + "  from GetBoothInfo.  " + 
                  //        msg.Message);
                    swal("", "Unknown Error Code  " + msg.Code + "  from GetBoothInfo.  " + 
                    msg.Message, "error");
                }
                return;
            }
            numBooths = msg.length;
            for( boothIndex = 0; boothIndex < numBooths; boothIndex++) {
                currentMsg = msg[boothIndex];
				bthNum = currentMsg.BoothNumber.replace(/^\s+|\s+$/g,'');
                
				boothObj = util.findBoothObject( bthNum, data.booths);
                
                if( boothObj === null) {
                    console.log( "booth null for number: " + bthNum);
                }
                
                    // clear existing graphics
                graphic = boothObj.graphic;
				graphic.path = [];
				
				graphic.numPoints = currentMsg.NumCorners;
				for (i = 0; i < graphic.numPoints; i++) {
					graphic.path.push( { x:currentMsg.Corners[i].X, y:currentMsg.Corners[i].Y});
				}
				fp.getBoothMinMax( graphic);
				
				boothObj.areaF = currentMsg.Area;
				boothObj.areaM = currentMsg.MArea;
				boothObj.dimF = currentMsg.Size;
				boothObj.dimM = currentMsg.MSize;
				boothObj.flyout = currentMsg.Flyout ? currentMsg.Flyout : ""; 
                
                if( currentMsg.IsRented) {
                    boothObj.status = fp.BOOTH_RENTED;
                }
                else if( currentMsg.IsOnHold) {
                    boothObj.status = fp.BOOTH_HOLD;
                    //  ????  update legend if not showing hold.
                }
                else if( currentMsg.IsDeleted) {
                    boothObj.status = fp.BOOTH_AVAILABLE;
                    mgr.deleteDisplayBooth( boothObj.number);
                }
                
                mgr.addDisplayBooth( boothObj);		// if object needed
                
				graphic.expColor = util.fixColor(currentMsg.Color);
				graphic.lineWeight = 1;
				graphic.alpha = config.BOOTH_ALPHA;	
                
				fp.getBoothColor( graphic, boothObj.status);
				
                    //  ??  gradient ??
                if( config.bBoothGradient && graphic.fillColor !== "") {
                    graphic.strokeColor = graphic.fillColor;
                    graphic.fillStyle = fp.createBoothGradient( graphic);
                }
                else {
                    graphic.fillStyle = graphic.fillColor;
                }
                
                graphic.displayColor = boothObj.graphic.fillStyle;
                
				if( currentMsg.NumberExhibitorText > 0) {
					for( i = 0; i < currentMsg.NumberExhibitorText; i++) {
						font = currentMsg.ExhibitorTexts[i].TextSize + "px " +                            config.FLOOR_PLAN_FONT;
						
						//  in test cases, isDimension from JSON string converted to integer! so "=="
						txt = {
							x: parseInt( currentMsg.ExhibitorTexts[i].Nx, 10),
							y: parseInt( currentMsg.ExhibitorTexts[i].Ny, 10),
							dRot: parseInt( currentMsg.ExhibitorTexts[i].Rotation, 10),
							rotation: parseInt( currentMsg.ExhibitorTexts[i].Rotation, 10)*Math.PI/180,
							text: currentMsg.ExhibitorTexts[i].Text,
							fontSize: currentMsg.ExhibitorTexts[i].TextSize,
							font: font,
							fill: config.clrBoothText,
							isDimension: Boolean( currentMsg.ExhibitorTexts[i].isDimension)
						};
						
						if( txt.isDimension) {
							txt.fill = config.clrBoothDimensions;
							graphic.dimensionText.push( txt);
						}
						else {
							graphic.text.push( txt);
						}
					}
				}
				font = currentMsg.TextSize + "px " + config.FLOOR_PLAN_FONT;
				txt = {
					x: parseInt( currentMsg.Nx, 10),
					y: parseInt( currentMsg.Ny, 10),
					dRot: parseInt( currentMsg.Rotation, 10),
					rotation: parseInt( currentMsg.Rotation, 10)*Math.PI/180,
					text: bthNum,
					fontSize: currentMsg.TextSize,
					font: font,
					fill: config.clrBoothText
				};
                
				graphic.text.push( txt);
				
				if( bSyncFromLogin) {
					boothsDone += 1;
					progress =  0.5 * (boothsDone / totalBooths) + 0.5;
					document.dispatchEvent( new FxEvent( "Sync_Progress", { "prog": progress} ));
				}
			}
            fp.updateBooth( boothObj);
			if( boothObj.number === data.pendingZoomBoothNumber) {
				document.dispatchEvent( new FxEvent( "Booth_Selected", {boothIndex: boothObj.index} ));
				data.pendingZoomBoothNumber = "";
			}	
        }
        bRequestPending = false;
        checkForMore();
    }
    
    function requestLogMessages() {
        var reqUrl = "fx/actions";
        
        if(config.isXML){
            reqUrl += "?databaseName=" + encodeURIComponent( config.eventName);
        
            if ( config.hasMultipleViews) {
                reqUrl += "&viewName=" + encodeURIComponent( config.viewTitle);
            }
            
            reqUrl += "&idx=" + lastMsgNumber;
        }
        else{
            reqUrl += "?idx=" + lastMsgNumber;

            if ( config.hasMultipleViews) {
                reqUrl += "&viewName=" + encodeURIComponent( config.viewTitle);
            }
        }

        
        
        if( lastMsgNumber === undefined) {
            return;
        }
        addRequest( "GET", reqUrl, cbLogMessage);
    }
    
    function requestBoothInfo( arBooths) {
        var reqUrl = "fx/boothInfo?";
        var booth = null;
        
        if(config.isXML){
            reqUrl += "databaseName=" + encodeURIComponent( config.eventName);
            if(config.hasMultipleViews){
                reqUrl += "&viewName=" + encodeURIComponent( config.viewTitle);
            }
        }
        
            //  limit url to 2083 characters - IE, 2048 IIS ?,   4000 chars Apache
        while( arBooths.length > 0 && reqUrl.length + arBooths[0].number.length < 2040) {
            booth = arBooths.shift();
            reqUrl += "&booths=" + encodeURIComponent( booth.number);

            if(config.hasMultipleViews){
                reqUrl += "&viewName=" + encodeURIComponent( config.viewTitle);
            }
        }
        addRequest( "GET", reqUrl, cbBoothInfo);
    }
    
    function openEvent( user, password, eventName) {
        var reqUrl = "fx/login";
        var credentials = btoa( user + ":" + password);
        
        reqUrl += "?creds=" + credentials;
        reqUrl += "&databaseName=" + encodeURIComponent( eventName);
        
        bRequestPending = true;
        
//        console.log( "sending open event: " + eventName + "   creds: " + credentials);
        sendRequest( "POST", reqUrl, cbOpenEvent);
    }

    function enterMode (mode,token) {
        var reqUrl = "fx/entermode";
        
        reqUrl += "?mode=" + mode;
        
        bRequestPending = true;
        
//        console.log( "sending open event: " + eventName + "   creds: " + credentials);
        sendRequest( "POST", reqUrl, cbOpenEvent, null, token);
    }
    
    function cbOpenEvent( msg) {
        var loc = "";
        var result = false;
        bRequestPending = false;

        if(!config.isXML){
            msg.Token = true;
        }
        
        if( msg && msg.Token) {
            
            if(config.isXML){
                token = msg.Token;
            }
            
            loggedIn = true;
            result = true;
			
//            console.log( "   open event callback - token: " + msg.Token);
       // ONLY STORE IF ID AND PASSWORD FROM LOGIN SCREEN, NOT FROM MESSAGE
			if( !loggedInFromCredentials && config.isXML) {
				loc = location.hostname + location.pathname;
				localStorage.saveSalesInfo( token, loc);
            }
            
            if(config.isXML) {
                document.dispatchEvent( new FxEvent( "Sales_Token", { status: "Connected"}));
            }
            else {
                document.dispatchEvent( new FxEvent( "Bearer_Token", { status: "Connected"}));
            }
            
        }
        else {
			loggedInFromCredentials = false;
            if( msg) {
                console.log( "   open event callback - message: " + msg + "  no token " + msg.Message);
            }
            else {
                console.log( "Open event returned NULL");
            }
        }
        document.dispatchEvent( new FxEvent( "Open_Result", { success: result, message: msg.Message}));
    }
    
    function checkToken() {
        token = localStorage.getSalesToken( location.hostname + location.pathname, config.eventName);
        if( token !== "") {
            getRatePlans();
        }
        else {
            document.dispatchEvent( new FxEvent( "Sales_Token", { status: "Failed"}));
        }
    }

    function checkBearerToken() {

        // Can't use cookies anymore 
        //token = getCookieValue("token");
        token = "na";

        if(token !== ""){

            enterMode(config.salesMode, token);
        }
        else{
            document.dispatchEvent( new FxEvent("Bearer_Token", { status: "Failed"}));
        }
    }

    function getCookieValue(a) {
        var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    }

        // For Informa - credentials provide in message from parent window ( SalesForce)
    function checkCredentials() {
        var credentials = getExternalCredentials();
        if( credentials === null) {
            document.dispatchEvent( new FxEvent( "Sales_Token", { status: "Failed"}));
        }
        else {
            var ar = credentials.split(":");
            // Add :0 to the end of creds before encoding to remove FX Sales button
			if( ar.length === 3 && ar[2] === "0") {
				config.salesUpdateOnly = true;
			}
			loggedInFromCredentials = true;
            openEvent( ar[0], ar[1], config.eventName);
        }
    }
    
    function getExternalCredentials() {
        var credentials = null;
        
        if( typeof( getCredentials) === "function") {
            credentials = getCredentials();
            if( credentials !== null) {
                credentials = atob( credentials);
            }
        }
        return credentials;
    }
    
    function getCompanyList() {
        if(config.isXML){
            var reqUrl = "exhibitors/all?databaseName=" + config.eventName;
            reqUrl += "&$select=ExhibitorId,ExhibitorName,Contact,Email,Phone";
        }
        else{
            var reqUrl = "exhibitors/all?$select=ExhibitorId,ExhibitorName,Contact,Email,Phone";
        }

        
        addRequest( "GET", reqUrl, cbCompanies);
    }
    
    function cbCompanies( msg) {
        if( msg) {
            document.dispatchEvent( new FxEvent( "Companies_Result", msg));
        }
        checkForMore();
    }
    
    function createNewExhibitor( name, id, addr1, addr2, city, country, state, zip, contact, phone, fax, email, site, profile) {
        var obj;
        var reqUrl = "exhibitors/add";
        
        if(config.isXML){
            reqUrl += "?databaseName=" + encodeURIComponent( config.eventName);
        }
        
        obj = {
              "Address1": addr1,
              "Address2": addr2,
              "City": city,
              "Contact": contact,
              "Country": country,
              "DisplayOnDrawing": name,
              "Email": email,
              "ExhibitorId": id,
              "ExhibitorName": name,
              "Fax": fax,
              "Phone": phone,
              "PostalCode": zip,
              "PrimaryGroup": "",
              "State": state,
              "WebSite": site,
              "ProductDescription": profile
        };
        console.log(obj);
        addRequest( "POST", reqUrl, cbExhibitorCreated, obj);
    }
    
    function cbExhibitorCreated( msg) {
        bRequestPending = false;
        //  if command works ==> msg is null
        //  if it fails ==> msg { code: edge fail code, message: error message}
        
        document.dispatchEvent( new FxEvent( "Sales_Result", msg));
        checkForMore();
    }
    
    function getExhibitorName( boothNumber) {
        var reqUrl = "booths";
        reqUrl += "?boothNumber=" + boothNumber;

        if(config.isXML){
            reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
        }
        
        reqUrl += "&$select=BoothNumber,HoldExhibitorId,HoldExhibitorName";
        
        addRequest( "GET", reqUrl, nameFromBooth, null);
    }
    
    function nameFromBooth( msg) {
        var obj;
        var reqUrl = "exhibitors";
        bRequestPending = false;
        
        if( msg) {
            if( msg.HoldExhibitorName !== "") {
                obj = {
                    ExhibitorName : msg.HoldExhibitorName
                };
                document.dispatchEvent( new FxEvent( "Exhibitor_Name_Result", obj));
            }
            else {
                reqUrl += "?id=" + msg.HoldExhibitorId;
                if(config.isXML){
                    reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
                }
                reqUrl += "&$select=ExhibitorId,ExhibitorName";

                addRequest( "GET", reqUrl, cbExhibitorName, null);
            }
        }
        checkForMore();
    }
    
    function cbExhibitorName( msg) {
        bRequestPending = false;
        if( msg) {
            document.dispatchEvent( new FxEvent( "Exhibitor_Name_Result", msg));
        }
        checkForMore();
    }
    
    //////////////////////////////////////////////////////////////
    
    function logout( external) {

        if (config.isXML){
            
            loggedIn = false;
            clearTimeout( syncTimer);
            arPendingRequests = [];
            arPendingBooths = [];
            var reqUrl = "fx/logout";
            externalLogout = external;
            
            addRequest( "POST", reqUrl, cbLogout);
        }
        else{
            // Don't need to logout of events in FX 5? 
            //sales.resetMode( external);
        }
    }

    function resetMode( external) {
        loggedIn = false;
        clearTimeout( syncTimer);
        arPendingRequests = [];
        arPendingBooths = [];
        var reqUrl = "fx/resetMode";
        externalLogout = external;
        
        addRequest( "POST", reqUrl, cbLogout);
    }
    
    function cbLogout( msg) {
        bRequestPending = false;
        
        if( externalLogout && window.salesLogoutCallback) {
            window.salesLogoutCallback();
        }
        if( msg) {
            loggedIn = false;
            token = "";
        }
        else {
            console.log( "Log out Failed - error: ?");
        }
    }
    
    function getRatePlans() { 
    if(config.isXML){
        var reqUrl = "rateplans/all?databaseName=" + config.eventName;
        reqUrl += "&$select=Name";
    }
    else{
        var reqUrl = "rateplans/all?$select=Name";
    }
        addRequest( "GET", reqUrl, cbRatePlans, "", token);
    }
    
    function cbRatePlans( msg) {
        bRequestPending = false;
        if( !loggedIn) {
            if( msg) {
                if(config.isXML){
                    document.dispatchEvent( new FxEvent( "Sales_Token", { status:"Connected"}));
                }
                else{
                    document.dispatchEvent( new FxEvent( "Bearer_Token", { status:"Connected"}));
                }
            }
            else {
				token = "";
                document.dispatchEvent( new FxEvent( "Sales_Token", { status:"Failed"}));
            }
        }
        else {
            document.dispatchEvent( new FxEvent( "Result_Rate_Plans", msg));
        }
        //checkForMore(); // Was creating duplicate initial calls for boothInfo when refreshing the page? -AH 5/07/2019
    }
	
	
	
    function getEventStatistics() { 
        if(config.isXML){
            var reqUrl = "events/stats?databaseName=" + config.eventName;
        }
        else{
            var reqUrl = "events/stats";
        }
        
        addRequest( "GET", reqUrl, cbEventStatistics);
    }
    
    function cbEventStatistics( msg) {
        bRequestPending = false;
        document.dispatchEvent( new FxEvent( "Result_Event_Statistics", msg));
		
        checkForMore();
    }
	
	
	
///////////////////////////////////////////////////////////////////////////////////////    
    function getDeletedBoothList() {
        var reqUrl = "booths/all";
        
        if(config.isXML){
            reqUrl += "?databaseName=" + encodeURIComponent( config.eventName);
            reqUrl += "&deletedFilter=OnlyDeleted";
        }
        else{
            reqUrl += "?deletedFilter=OnlyDeleted";
        }
        reqUrl += "&$select=BoothNumber,Area,IsDeleted";
        
        addRequest( "GET", reqUrl, cbDeletedBooths, null);
    }
////////////////////////////////////////////////////////////////////////////////////////    
    function cbDeletedBooths( msg) {
        bRequestPending = false;
        document.dispatchEvent( new FxEvent( "Result_Deleted_Booths", msg));
        checkForMore();
    }
    
//-----------  Booth Functions  -----------------------------------------//
    function rentBoothRequest( boothNumber, exhibitorId, rate) {
        var reqUrl = "booths/rent";
        
        reqUrl += "?boothNumber=" + encodeURIComponent( boothNumber);
        reqUrl += "&exhibitorId=" + encodeURIComponent( exhibitorId);
        reqUrl += "&ratePlan=" + encodeURIComponent( rate);
        
        if(config.isXML){
            reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
        }
        
        addRequest( "PUT", reqUrl, cbBoothFunction);
    }
    
    function cbBoothFunction( msg) {
        //  if success --> sync soon!!
        bRequestPending = false;
        
//      document.dispatchEvent( new FxEvent( "Booths_changed", null));
        document.dispatchEvent( new FxEvent( "Sales_Result", msg));
    }
    
    function unrentBoothRequest( boothNumber) {
        var reqUrl = "booths/unrent";
        reqUrl += "?boothNumber=" + encodeURIComponent( boothNumber);
        if(config.isXML){
            reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
        }
        
        addRequest( "PUT", reqUrl, cbBoothFunction);
    }
    
    function holdBoothRequest( boothNumber, exhibitorId, exhibitorName, comment) {
        var reqUrl = "booths/hold";
        
        reqUrl += "?boothNumber=" + encodeURIComponent( boothNumber);
        if(config.isXML){
            reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
        }
        reqUrl += "&exhibitorId=" + encodeURIComponent( exhibitorId);
        reqUrl += "&exhibitorName=" + encodeURIComponent( exhibitorName);
        reqUrl += "&comment=" + encodeURIComponent( comment);
        
        addRequest( "PUT", reqUrl, cbBoothFunction);
    }
    
    function unholdBoothRequest( boothNumber) {
        var reqUrl = "booths/unhold";
        reqUrl += "?boothNumber=" + encodeURIComponent( boothNumber);
        if(config.isXML){
            reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
        }
        
        addRequest( "PUT", reqUrl, cbBoothFunction);
    }
    
    function combineBoothRequest( boothNumbers) {
        var arBth = boothNumbers.split( ", ");
        var combineAdjacent = 0;

        if ( config.combineAdjacentOnly){
            combineAdjacent = 2;
        }
        
        var reqUrl = "booths/combine";

        if(config.isXML){
            reqUrl += "?databaseName=" + encodeURIComponent( config.eventName);
            reqUrl += "&boundary=" + encodeURIComponent( combineAdjacent);
        }
        else{
            reqUrl += "?boundary=" + encodeURIComponent( combineAdjacent);
        }
        
        addRequest( "PUT", reqUrl, cbBoothFunction, arBth);
    }
    
    function uncombineBoothRequest( boothNumber) {
        var reqUrl = "booths/uncombine";
        reqUrl += "?boothNumber=" + encodeURIComponent( boothNumber);
        if(config.isXML){
            reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
        }
        
        addRequest( "PUT", reqUrl, cbBoothFunction);
    }
    
    function deleteBoothRequest( boothNumbers) {
        var arBth = boothNumbers.split( ", ");
        var reqUrl = "booths/delete";
        reqUrl += "?boothNumbers=" + encodeURIComponent( arBth);
        if(config.isXML){
            reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
        }
        
        addRequest( "PUT", reqUrl, cbBoothFunction, arBth);
    }
    
    function undeleteBoothRequest( boothNumbers) {
        var arBth = boothNumbers.split( ", ");
        
        var reqUrl = "booths/undelete";
        if(config.isXML){
            reqUrl += "?databaseName=" + encodeURIComponent( config.eventName);
        }
        
        addRequest( "PUT", reqUrl, cbBoothFunction, arBth);
    }
    
    function divideBoothRequest( boothNumber, params) {
        var reqUrl = "fx/divide";
        
        if(config.isXML){
            reqUrl += "?databaseName=" + encodeURIComponent( config.eventName);
            reqUrl += "&orgBooth=" + encodeURIComponent( boothNumber);
        }
        else{
            reqUrl += "?orgBooth=" + encodeURIComponent( boothNumber);
        }

        reqUrl += "&newBooth1=" + encodeURIComponent( params.aNumber.trim());
        reqUrl += "&newBooth2=" + encodeURIComponent( params.bNumber.trim());
        reqUrl += "&sizeX=" +  params.sizeX;
        reqUrl += "&sizeY=" +  params.sizeY;
        
        addRequest( "POST", reqUrl, cbBoothFunction);
    }

    function changeBoothNumber( oldNumber, newNumber) {
        var reqUrl = "booths/changenumber";
        reqUrl += "?oldNumber=" + oldNumber.trim();
		reqUrl += "&newNumber=" + newNumber.trim();
        if(config.isXML){
            reqUrl += "&databaseName=" + encodeURIComponent( config.eventName);
        }
        
        addRequest( "PUT", reqUrl, cbBoothFunction, null);
	}
	
    function cbLogMessage( msg) {
        var msgNum = 0;
        //  Allow for more calls if > 500 messages !!
        if( msg) {
            lastMsgNumber = msg.LastRecordIndex;
            //var arCheckBooths = [];
            totalMessages += msg.Count;     // used t0 calculate progress bar
            for( msgNum = 0; msgNum < msg.Count; msgNum++) {

                processLogMessage( msg.LogMessages[ msgNum]);

                // if(config.hasMultipleViews){
                    
                //     if ( msgNum == msg.Count - 1)
                //     {
                //         arCheckBooths.push( { number: msg.LogMessages[ msgNum].Booth});

                //         //if(requestBoothInfo( arCheckBooths)){ // This is not correct and is preventing updates from processing

                //             processLogMessage( msg.LogMessages[ msgNum]);
                //         //}

                //     }
                //     else{

                //         arCheckBooths.push( { number: msg.LogMessages[ msgNum].Booth});

                //     }


                // }
                // else{
                //     processLogMessage( msg.LogMessages[ msgNum]);
                // }

                
            }
            if( msg.Count <= 500) {
                if( bSyncFromLogin) {
                    totalBooths = arPendingBooths.length;
                    document.dispatchEvent( new FxEvent( "Sync_Progress", { "prog": 0.5} ));
                }
                bSyncInProgress = false;
            }
            bRequestPending = false;
        }
        checkForMore();
    }
        
    function processLogMessage( msg) {
        var oldBoothObj = null;
        var arBoothNums;
        var boothNumber = "";
        var boothObj = null;
		var newName = "";
        var progress = 0;
        
		if( msg.Action === CMDACTION_CHANGEBOOTHNUMBER) {
			boothObj = getBoothObject( msg.OldValue);
		}
		else {
			boothObj = getBoothObject( msg.Booth);
		}
        
        if( bSyncFromLogin) {
            messagesProcessed += 1;
            progress = 0.5 * messagesProcessed / totalMessages;
            document.dispatchEvent( new FxEvent( "Sync_Progress", { "prog":progress}) );
        }

        if( boothObj !== null) {
            
//            if( boothObj.number === "161") {
//                console.log( "Command  "  + msg.Action + "   booth: " + boothObj.number);
//            }
            switch( msg.Action) {
                case CMDACTION_RENTBOOTH:
//					wasAvailable = boothObj.status === "0";
                    boothObj.status = fp.BOOTH_RENTED;

                    addToPending( boothObj);
                    fp.removeBoothText( boothObj);
                    
                    mgr.updateTablesForRentHold( boothObj, msg.ExhibitorId, msg.Comment);
                    //  might need to update exhibitor info
                    break;

                case CMDACTION_HOLDBOOTH:
                    if( boothObj.status !== fp.BOOTH_RENTED) {  // EXPOCAD implementation of Wait list
//						wasAvailable = boothObj.status === "0";
                        boothObj.status = fp.BOOTH_HOLD;
                        fp.removeBoothText( boothObj);
                        addToPending( boothObj);
                        
                        mgr.updateTablesForRentHold( boothObj, msg.ExhibitorId, msg.Comment);
                    }
                    break;

                case CMDACTION_UNRENTBOOTH:
                case CMDACTION_UNHOLDBOOTH:
                var arExhibIds = boothObj.exhibitorIndex.split( ",");
                for(i = 0; i < arExhibIds.length; i++){    
                    boothObj.exhibitorIndex = arExhibIds[i];
                    fp.removeBoothText( boothObj);
                    addToPending( boothObj);
                    
//                    if( msg.ExhibitorId === "") {
                    if( msg.Misc !== "HOLD") {
                        boothObj.status = fp.BOOTH_AVAILABLE;
                        mgr.updateReleasedBooth( boothObj);
                    }
                    else {      // Unrent to Hold                        
                            boothObj.status = fp.BOOTH_HOLD;
                            mgr.updateReleasedBooth( boothObj);
                            mgr.updateTablesForRentHold( boothObj, msg.ExhibitorId, msg.Comment);
                    }
                }
                    break;
					
				case CMDACTION_BOOTHNAMEOVERRIDE:
                    fp.removeBoothText( boothObj);
                    addToPending( boothObj);
						// new name in 'comment' property on override
						//original name in .Misc on reset ( i.e. undo override), and .Comment = ""
					if( msg.Comment !== "") {
						newName = msg.Comment;
					}
					else {
						newName = msg.Misc;
					}
					
					mgr.changeExhibiterName( boothObj, newName, msg.ExhibitorId);
					break;

                case CMDACTION_MOVEEXHIBITOR:
                    oldBoothObj = getBoothObject( msg.OldValue);    // From
                    oldBoothObj.status = fp.BOOTH_AVAILABLE;
                    fp.removeBoothText( oldBoothObj);

                    mgr.updateReleasedBooth( boothObj);
                    addToPending( oldBoothObj);

                    boothObj.status = fp.BOOTH_RENTED;                  // To
                    mgr.updateTablesForRentHold( boothObj, msg.ExhibitorId, msg.Comment);
                    //arPendingExhibitors.push( exhObj);		// IF EXHIBITOR DID NOT EXIST !!??
                    addToPending( boothObj);
                    break;

                case CMDACTION_DELETEBOOTH:
                    removeFromPending( boothObj);
                    fp.removeBoothText( boothObj);

                    boothObj.graphic.path = null;
                    boothObj.status = fp.BOOTH_DELETED;
                    
                    mgr.deleteDisplayBooth( boothObj.number);
                    break;

                case CMDACTION_UNDELETEBOOTH:
                    boothObj.status = fp.BOOTH_AVAILABLE;
                    addToPending( boothObj);
                    break;

                case CMDACTION_CHANGEBOOTHNUMBER:
                    fp.removeBoothText( boothObj);

                    boothObj.number = msg.Booth;
                    addToPending( boothObj);
                    break;

                case CMDACTION_CREATEBOOTH:
                    boothObj.status = fp.BOOTH_AVAILABLE;
                    addToPending( boothObj);
                    break;

                case CMDACTION_MOVEBOOTH:
                    fp.removeBoothText( boothObj);
                    addToPending( boothObj);
                    break;

                case CMDACTION_COMBINEBOOTH:
                    arBoothNums = msg.OtherBooths.split( ",");
                    while( arBoothNums.length > 0) {
                        boothNumber = arBoothNums.pop();

                        oldBoothObj = util.findBoothObject( boothNumber, data.booths);

                        if( oldBoothObj !== null) {
                            fp.removeBoothText( oldBoothObj);
                            if( oldBoothObj.number === msg.Booth) {
                                addToPending( oldBoothObj);		// to redraw the remaining booth
                            }
                            else {      //  booths don't exist anymore
                                oldBoothObj.graphic.path = null;
                                oldBoothObj.status = fp.BOOTH_DELETED;
                                removeFromPending( oldBoothObj);
                                mgr.deleteDisplayBooth( boothNumber);
                            }
                        }
                    } 
                    break;

                case CMDACTION_UNCOMBINEBOOTH:
                    var arNums = msg.OtherBooths.split( ",");
                        // booths being added to floor plan by uncombining them
                    while( arNums.length > 0) {
                        boothNumber = arNums.pop();
                        boothObj = getBoothObject( boothNumber);

                        addToPending( boothObj);
                        boothObj.status = fp.BOOTH_AVAILABLE;
//						mgr.addDisplayBooth( boothObj);
                    }
                    fp.removeBoothText( boothObj);
                    break;

                case CMDACTION_RESIZE:
                    fp.removeBoothText( boothObj);
                    addToPending( boothObj);
					//  CHANGE LABEL IN BOOTH LIST !
					mgr.updateAvailableLabel( boothObj);
                    break;

                case CMDACTION_ADDCHILDEXHIBITOR:
                        
                //Look to see if exhibitor is already in the list
                //If so, append booth to list.  If not, add exhibitor to list
                
                addToPending( boothObj);
                // Remove booth floorplan text
                        fp.removeBoothText( boothObj);
                        //boothObj.exhibitorIndex = boothObj.exhibitorIndex;
                        //mgr.updateTablesForChildExhib( boothObj, msg.ExhibitorId, msg.Comment, true);
                    break;

                case CMDACTION_REMOVECHILDEXHIBITOR:

                        addToPending( boothObj);
                        // Remove booth floorplan text
                                fp.removeBoothText( boothObj);
                                
                    break;

                default:
                    console.log( "No process for command: " + msg.Action + "  booth: " + msg.Booth + 
								"  other booths: " + msg.OtherBooths + "  misc: " + msg.Misc + "  comment: " +
								msg.Comment + "   old value: " + msg.OldValue);
            }
        }
    }

    function sendRequest( type, url, callback, param, token) {
        var req = null;
		var reqUrl = data.salesUrl + url;
        
        if( window.XMLHttpRequest) {
            req = new XMLHttpRequest();

        }
        else {
         //   alert( "Could not create request for data");
            swal("", "Could not create request for data", "error");
            return;
        }

		req.onreadystatechange = function() {
			var msg = null;
            var contentType = "";
            
//            console.log( "http state: " + req.readyState + "  status: " + req.status +
//                        "  status text: " + req.statusText + "  response: " +
//                       req.response);
            
			if( req.readyState === 4) {

                if( req.status === 200) {
                    if( req.response === null || req.response === undefined || req.response === "") {
                        msg = { Code: 200};
                    }
                    else {
                        try {
                            msg = JSON.parse( req.responseText);
                        }
                        catch( err) {
                            console.log( " status 200 with content: " + req.responseText);
                        }
                    }
                }
                else if( req.status === 503) {
                    console.log( "HTTP status: " + req.status + "  response: " + req.response);
					//   supply a message !!!!
					msg = { code: 503, message:"Can Not Connect To API"};
                }
                else if( req.status === 404) {
                    contentType = String( req.getResponseHeader( "Content-Type"));
                    
                    if( !loggedIn) {
                        if( contentType.substr( 0, 9) === "text/html") {
                         //   alert( "Configuration error!");
                            swal("", "Configuration error!", "error");
                        }
                        else {
                     //       alert( req.responseText);
                            swal("", req.responseText, "error");
                        }
                    }
                    else {
                        if( contentType.substr( 0, 9) === "text/html") {
                         //   alert( "Configuration error!");
                            swal("", "Configuration error!", "error");
                        }
                        else {
                            if( req.responseText === "Booth Not Found") {
                                msg = { code: 404, message:"Booth Not Found"};
                            }
                            else {
                                if(!config.hasMultipleViews){ // Handle 404 responses to FX/boothInfo when change occurs outside of view
                          //      alert( "Unkown error: " + req.responseText);
                                swal("", "Unknown error: " + req.responseText, "error");
                                }
                            }
                        }
                    }
                }
                else if( req.status === 409) {
//                    console.log( "   HTTP status " + req.status +
//                                "  - response text: " + req.responseText);
                    msg = { Code: 200};   //  ??????  so far command has always worked!
                }
                else if( req.status === 400 || req.status === 500) {
                    // get 500 on rent id booth already rented
                    console.log( "   HTTP status " + req.status +
                                "  - response text: " + req.responseText);
                    try {
                        var newMsg = document.getElementById('sPrompt');
                        newMsg.classList.add('wrongLoginTwo');
                        msg = JSON.parse(req.responseText);
                        newMsg.textContent = msg.Message;
                    }
                    catch( err2) {
                        swal("", "error parsing response - status" + req.status + 
                        "  msg: " + err2.message + "  in " + req.responseText, "error");

                    //    alert( "error parsing response - status" + req.status + 
                    //          "  msg: " + err2.message + "  in " + req.responseText);
                    }
                }
                else if( req.status === 401) {
                    //  can occur if logged in user closes page with out log out
                    console.log( "Status 401 - Message: " + req.status);
//                    msg = {
//                        code: req.status,
//                        message: req.status
//                    };
                }
                else if( req.status === 429) {  // Too many requests - rate limit
                    // retry after 1 second
                    console.log( "Status 429 - Too many requests");
                }
                callback( msg);
			}
		};
		
        req.open( type, reqUrl, true);
		req.setRequestHeader( "Accept", "application/JSON");
        if( token) {
            var label;

            if( config.isXML){
                label = "X-FxSales-Token";
                req.setRequestHeader( label, token);
            }
            else{
                //label = "Authorization";
                //token = "Bearer " + token;
            }
            
            //req.setRequestHeader( label, token);
        }
        else {
            req.withCredentials = true;
        }
        if( param !== null && param !== undefined) {     // type = "PUT"
//            console.log( "setting Content-Type for req type: " + type + "   url: "  + reqUrl + "   params: " +
//                       param);
            req.setRequestHeader( "Content-Type", "application/JSON");
            param = JSON.stringify( param);
        }
        else{
            param = null;
        }
        
        req.send(param);
    }
    
    function hatchBooths(color, availability, size, grey, boothIndexes ) {        
        if( data.hatchedBooths == true){
            // Clear on execution if already exists
            clearHatchedBooths();
        }
        
        var i = 0;
        
        var specifcArray = boothIndexes === -1 ? [] : String(boothIndexes).split( ",");
        var arMatched = [];
        var arUnMatched = [];
        if( color == null || color == "") {
            color = config.clrSelected
        }

        for(i = 0; i < data.displayBooths.length; i++) {
            
            var boothIndex = data.displayBooths[i].boothIndex;

            // FILTER: availability == 0: Available, 1: On Hold, 2: Rented, 3: ALL
            // FILTER: size == dimF, dimM, areaF, or areaM EX: "10' x 10'" or "100 sqft"
            if( availability == 0){
                if( data.displayBooths[i].bAvailable == true) {
                    
                    if ( size != null && size != "" ) {
                        if( data.booths[boothIndex].areaF == size || data.booths[boothIndex].dimF == size 
                            || data.booths[boothIndex].dimM == size || data.booths[boothIndex].areaM == size) {
                                arMatched.push(data.displayBooths[i].boothIndex);
                            }
                            else {
                                arUnMatched.push(data.displayBooths[i].boothIndex);
                            }
                    }
                    else {
                        arMatched.push(data.displayBooths[i].boothIndex);
                    }
                }
                else {
                    arUnMatched.push(data.displayBooths[i].boothIndex);
                }
            }
            else if( availability == 2) {
                //Currently includes on hold
                if( data.displayBooths[i].bAvailable == false) {
                    if ( size != null && size != "" ) {
                        if( data.booths[boothIndex].areaF == size || data.booths[boothIndex].dimF == size 
                            || data.booths[boothIndex].dimM == size || data.booths[boothIndex].areaM == size) {
                                arMatched.push(data.displayBooths[i].boothIndex);
                            }
                            else {
                                arUnMatched.push(data.displayBooths[i].boothIndex);
                            }
                    }
                    else {
                        arMatched.push(data.displayBooths[i].boothIndex);
                    }
                }
                else {
                    arUnMatched.push(data.displayBooths[i].boothIndex);
                }
            }
            else if( availability == 3) {
                //All availabilty 
                if ( size != null && size != "" ) {
                    if( data.booths[boothIndex].areaF == size || data.booths[boothIndex].dimF == size 
                        || data.booths[boothIndex].dimM == size || data.booths[boothIndex].areaM == size) {
                            arMatched.push(data.displayBooths[i].boothIndex);
                        }
                        else {
                            arUnMatched.push(data.displayBooths[i].boothIndex);
                        }
                }
                else {
                    arMatched.push(data.displayBooths[i].boothIndex);
                }
            }


        }

        var graphic = null;

        // Highlight these booths
        if( arMatched.length !== 0) {
            for( i = 0; i < arMatched.length; i++) {
                graphic = arBoothGraphics[ arMatched[i]];
                if( graphic) {
                    graphic.displayColor = color;
                }
            }

            data.hatchedBooths = true;
        }
        
        // Option to Gray out non-highlighted booths
        if ( grey) {
            if( arUnMatched.length !== 0) {
                for( i = 0; i < arUnMatched.length; i++) {
                    graphic = arBoothGraphics[ arUnMatched[i]];
                    if( graphic) {
                        graphic.displayColor = "#F8F8F8";

                        if(graphic.strokeColor != config.clrBoothBorder){
                            graphic.saveColor = graphic.strokeColor;
                        }

                        graphic.strokeColor = "#E8E8E8";

                        for ( j = 0; j < graphic.text.length; j++) {
                            graphic.text[j].fill = "#E8E8E8";
                        }
                    }
                }
                
                data.hatchedBooths = true;
            }
        }

        arUnMatched = [];
        arMatched = [];
        specifcArray = [];
        updateNeeded = true;

        //document.dispatchEvent( new FxEvent( "Sales_Result", null))
    }

    function clearHatchedBooths() {
        for( i = 0; i < data.displayBooths.length; i++) {
            graphic = arBoothGraphics[ data.displayBooths[i].boothIndex];
            if( graphic) {
                graphic.displayColor = graphic.fillStyle;

                if( graphic.saveColor != ""){
                    graphic.strokeColor = graphic.saveColor;
                    graphic.saveColor = "";
                }
                else{
                    graphic.strokeColor = config.clrBoothBorder;
                }
                

                for ( j = 0; j < graphic.text.length; j++) {
                    graphic.text[j].fill = config.clrBoothText;
                }
            }
        }

        data.hatchedBooths = false;
        updateNeeded = true;
}

    
    return {
        CMD_DIVIDE: CMD_DIVIDE,
        CMD_RENT: CMD_RENT,
        CMD_UNRENT: CMD_UNRENT,
        CMD_HOLD: CMD_HOLD,
        CMD_UNHOLD: CMD_UNHOLD,
        CMD_COMBINE: CMD_COMBINE,
        CMD_UNCOMBINE: CMD_UNCOMBINE,
        CMD_DELETE: CMD_DELETE,
        CMD_UNDELETE: CMD_UNDELETE,
        CMD_NEW_EXHIBITOR: CMD_NEW_EXHIBITOR,
		CMD_EVENT_STATISTICS: CMD_EVENT_STATISTICS,
        CMD_CHANGE_NUMBER: CMD_CHANGE_NUMBER,
        CMD_HATCH_BOOTHS: CMD_HATCH_BOOTHS,
		changeBoothNumber: changeBoothNumber,
        checkCredentials: checkCredentials,
        checkToken: checkToken,
        checkBearerToken: checkBearerToken,
        combineBoothRequest: combineBoothRequest,
        commandLabels: commandLabels,
        createNewExhibitor: createNewExhibitor,
        deleteBoothRequest: deleteBoothRequest,
        divideBoothRequest: divideBoothRequest,
        getCompanyList: getCompanyList,
        getDeletedBoothList: getDeletedBoothList,
		getEventStatistics: getEventStatistics,
        getExhibitorName: getExhibitorName,
        getRatePlans: getRatePlans,
        getLoggedIn: function() {
            return loggedIn;
        },
        holdBoothRequest: holdBoothRequest,
        init: init,
        logout: logout,
        openEvent: openEvent,
        enterMode: enterMode,
        resetMode: resetMode,
        rentBoothRequest: rentBoothRequest,
        setFloorplan: function( value) {
            fp = value;
        },
        setConnectionParams: setConnectionParams,
        setLastMessage: function( value) {
            lastMsgNumber = value;
        },
        setLoggedIn: function( value) {
            loggedIn = value;
        },
        syncNow: syncNow,
        syncWithEdge: function() {
            readyForUpdates = false;
            bSyncFromLogin = true;
            syncWithEdge();
        },
        uncombineBoothRequest: uncombineBoothRequest,
        undeleteBoothRequest: undeleteBoothRequest,
        unholdBoothRequest: unholdBoothRequest,
        unrentBoothRequest: unrentBoothRequest,
        hatchBooths: hatchBooths,
        clearHatchedBooths: clearHatchedBooths
    };
};